import i18next from 'i18next'

import { validLanguages } from '../../constants/validLanguages'

export const getCurrentLanguage = () => {
  return i18next?.languages?.[0] || validLanguages[0]
}
